import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { toast } from 'sonner';
import { Eye, EyeOff } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_9c04a317-074b-47df-afd3-88339795c9c4/artifacts/rv087trj_logo.jpg";

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await login(email, password);
      toast.success('Autentificare reușită!');
      navigate('/admin');
    } catch (error) {
      const message = error.response?.data?.detail || 'Email sau parolă incorectă';
      toast.error(typeof message === 'string' ? message : 'Eroare la autentificare');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-10">
          <img src={LOGO_URL} alt="Shagun Surfaces" className="h-20 w-auto mx-auto mb-4" />
          <h1 className="font-serif text-2xl text-white">Panou Administrare</h1>
        </div>

        {/* Login Form */}
        <form onSubmit={handleSubmit} className="bg-[#121212] border border-white/10 p-8">
          <div className="space-y-6">
            <div>
              <label htmlFor="email" className="block text-[#A3A3A3] text-sm mb-2">
                Email
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-input w-full"
                placeholder="admin@shagunsurfaces.ro"
                required
                data-testid="login-email-input"
              />
            </div>

            <div>
              <label htmlFor="password" className="block text-[#A3A3A3] text-sm mb-2">
                Parolă
              </label>
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="form-input w-full pr-12"
                  placeholder="••••••••"
                  required
                  data-testid="login-password-input"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-4 top-1/2 -translate-y-1/2 text-[#A3A3A3] hover:text-white"
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full flex items-center justify-center"
              data-testid="login-submit-btn"
            >
              {loading ? (
                <span className="flex items-center gap-2">
                  <div className="w-4 h-4 border-2 border-black/30 border-t-black rounded-full animate-spin" />
                  Se autentifică...
                </span>
              ) : (
                'Autentificare'
              )}
            </button>
          </div>
        </form>

        {/* Back Link */}
        <div className="text-center mt-6">
          <a href="/" className="text-[#A3A3A3] hover:text-[#D4AF37] text-sm">
            ← Înapoi la site
          </a>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
